import { StyledWidget, StyledButton } from '@/components/styles';
import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import Icon from '@/assets/icons';
import * as gtag from '@/lib/gtag';
import { useHost } from '@/contexts/HostContext'
import { getCanonicalUrl } from '@/lib/locales'
import { buildWaRoute } from '@/lib/attribution'
import { useMobileKeyboard } from '@/hooks'

const WHATSAPP_HREF = '/wa'

export default function ContactWidgetButton({ fixed = true }) {
  const router = useRouter();
  const host = useHost();
  const pageUrl = getCanonicalUrl(router?.asPath || '/', host);
  const [href, setHref] = useState(WHATSAPP_HREF);
  const keyboardHidden = useMobileKeyboard(fixed);

  useEffect(() => {
    setHref(buildWaRoute(pageUrl, 'widget'));
  }, [pageUrl]);

  return (
    <StyledWidget static={!fixed} keyboardHidden={keyboardHidden}>
      <StyledWidget.Button
        green
        as="a"
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        aria-hidden={keyboardHidden || undefined}
        tabIndex={keyboardHidden ? -1 : undefined}
        onClick={() => {
          gtag.gtag_report_conversion('AW-18230806173/O4BNCKbCvMAcEJ2NkPVD');
        }}
      >
        <Icon name="whatsapp" fill="white" width={30} height={30} />
      </StyledWidget.Button>
    </StyledWidget>
  );
}
